import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import variablePie from "highcharts/modules/variable-pie";
import { Fuel } from "lucide-react";

if (typeof variablePie === "function") {
  variablePie(Highcharts);
} else if (variablePie.default && typeof variablePie.default === "function") {
  variablePie.default(Highcharts);
}

const APAdditivesUsed = ({ additiveUsage }) => {
  console.log("additiveUsed", additiveUsage);

  //   const additiveUsage = [
  //   { name: 'Biocide', y: 32000, z: 10000 },
  //   { name: 'Emission Reducer', y: 40000, z: 20000 },
  //   { name: 'Corrosion Inhibitor', y: 30000, z: 15000 },
  //   { name: 'Water Dispersant', y: 30000, z: 25000 },
  //   { name: 'Lubricity Enhancer', y: 20000, z: 32000 },
  //   { name: 'Stablizer', y: 60000, z: 40000 }
  // ]

  const options = {
    chart: {
      type: "variablepie",
      height: 400,
    },
    credits: { enabled: false },
    title: {
      text: null,
    },
    plotOptions: {
      variablepie: {
        dataLabels: {
          enabled: true,
          format: "{point.name}",
          style: {
            fontSize: "14px",
            fontWeight: "500",
            color: "#333333",
          },
        },
      },
    },
    tooltip: {
      headerFormat: "<b>Additives Used</b><br/>",
      pointFormat:
        '<span style="color:{point.color}">\u25CF</span> <b>{point.name}</b><br/>' +
        "Quantity: <b>{point.y}</b><br/>",
      style: {
        fontSize: "14px",
        fontWeight: "500",
      },
    },
    series: [
      {
        minPointSize: 50,
        innerSize: "30%",
        zMin: 0,
        name: "Additives",
        borderRadius: 5,
        data: additiveUsage,
        colors: [
          "#1a5276",
          "#d35400",
          "#27ae60",
          "#7d3c98",
          "#117864",
          "#a93226",
          "#b7950b",
          "#566573",
        ],
        dataLabels: {
          enabled: true,
          format: "{point.name}",
          style: {
            fontSize: "14px",
            fontWeight: "500",
            color: "#5c5c5cff",
          },
        },
      },
    ],
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 500,
          },
          chartOptions: {
            series: [
              {
                dataLabels: {
                  style: {
                    fontSize: "12px",
                    fontWeight: "bold",
                  },
                },
              },
            ],
          },
        },
      ],
    },
  };

  return (
    <div className="p-6 w-1/2">
      <div className="bg-white rounded-lg shadow-sm overflow-hidden hover:shadow-md transition-shadow">
        {/* Header */}
        <div className="px-6 py-4 border-b border-gray-200 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="p-1.5 bg-[#e1f5fb] text-[#27ade3] rounded-md">
              <Fuel className="w-5 h-5" strokeWidth="2" />
            </div>
            <div>
              <h2 className="text-lg font-semibold text-gray-900">
                Additives Used
              </h2>
            </div>
          </div>
        </div>

        {/* Chart */}
        <div className="p-4">
          <HighchartsReact highcharts={Highcharts} options={options} />
        </div>
      </div>
    </div>
  );
};

export default APAdditivesUsed;
